export default __webpack_public_path__ + "static/media/4-GlyGen-sfg2018.e4182dea.pdf";